
import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'

const pubResApi = {
  wechatLogin: (params) => getAction('/wechat/getWxMpUser', params),
  // 获取首页统计数据
  getCountByBusType: () => getAction('/wechat/index'),
  /**
    * @method 项目搜索
    * @param page{Object} 分页数据
    * @param tos{Array} 业务类型
    * @param keyword{String} 关键词
    * @param area{String} 地址
    * @param special_time{String} 模糊时间
    * @param start_time{String} 开始时间
    * @param end_time{String} 结束时间
    * @param min_price{String} 最低价格
    * @param max_price{String} 最高价格
    */
  getProjectInfoList: (params) => getAction('/wechat/search_product', params),

  /**
    * @method 判断是否登录
    * 未使用
    */
  isLogin: () => getAction('/isLogin'),
  /**
    * @method 保存微信code信息
    * @param {code} 微信登成功后返回的uncode
    * 未使用
    */
  getApiCode: (code) => getAction('getApiCode?code=' + code),
  /**
    * @method 判断是否登录，登录成功后创建一个用户信息
    */
  // newUserInfo: () => getAction('newUserInfo'),
  /**
    * @method 获取用户信息
    * 未使用
    */
  userDetailInfo: () => getAction('userDetailInfo/search'),
  /**
    * @method 获取企业数据   搜中标人
    */
  getCompanyBaseInfo: (params) => getAction('/wechat/search_success_bidder', params),
  /**
    * @method 查询公告详情
    */
  getAnnouncementInfo: (params) => getAction('/wechat/notice_show', params),
  /**
    * @method 判断是否关注
    */
  isConcern: (params) => postAction('isConcern/search', params),
  /**
    * @method 修改关注状态(关注成功)  关注/取消关注
    */
  createConcernInfo: (params) => postAction('/wechat/follow', params, {noLoading: false}),
  /**
    * @method 修改关注状态(取消关注成功)
    */
  deleteConcernInfo: (id) => getAction('concernInfo/delete?id=' + id),
  /**
    * @method 查询项目信息  项目详情
    */
  getProjectInfo: (params) => getAction('/wechat/project_show', params),
  /**
    * @method 获取项目设置的开标时间信息
    */
  getConcernProjectTipInfo: (params) => getAction('concernProjectTipInfo/search', params),
  /**
    * @method 确认设置开标提醒
    */
  upadteConcernProjectTipInfo: (params) => getAction('/wechat/wxProjectRemind/project_remind', params),
  /**
    * @method 获取关注项目列表  我的关注
    */
  getConcernProject: (params) => getAction('/wechat/my_follow_list', params),
  /**
    * @method 获取关注企业列表
    */
  getConcernCompany: (params) => getAction('concernCompany/search', params),
  /**
    * @method 获取意见反馈的类型
    * 未使用
    */
  feedBackType: () => getAction('getQuestionType/search'),
  /**
    * @method 意见反馈  发布留言
    */
  feedBackInfo: (params) => postAction('/wechat/add_message', params),
  /**
    * @method 获取企业详情  //中标人详情 POST http://data.ggzy.gov.cn/wechat/wx/success_bidder_show
    */
  successBidderShow: (params) => getAction('/wechat/success_bidder_show', params),
  /**
    * @method 获取订阅配置
    */
  getSubscribeInfoList: (params) => getAction('/wechat/get_subread_set_list', params),
  // getSubscribeInfoList: (params) => postAction('/wechat/wx/get_subread_set', params),
  /**
    * @method 删除订阅内容
    * 未使用
    */
  deleteUserDeleteSubscribeInfo: (params) => getAction('deleteUserDeleteSubscribeInfo/delete?id=' + params),
  /**
    * @method 获取列表数据  我的订阅内容
    */
  getUserSubscribeInfo: (params) => getAction('/wechat/my_subread_lists', params),
  /**
    * @method 获取订阅配置  获取推送设置
    */
  getSubscribeConfig: (params) => getAction('/wechat/get_push_set', params),
  /**
    * @method 更新订阅配置  推送设置
    */
  updateSubscribeConfig: (params) => getAction('/wechat/push_set', params),
  /**
    * @method 更新订阅条件
    */
  updateSubscribeInfo: (params) => postAction('/wechat/subread_set_update', params),
  /**
    * @method 招标人搜索
    */
  tenderUnitBaseInfo: (params) => getAction('/wechat/search_bidder', params),
  /**
    * @method 单个招标人详情 POST http://data.ggzy.gov.cn/wechat/wx/bidder_show
    */
  getTenderUnitDetailVo: (params) => getAction('/wechat/bidder_show', params, {noLoading: false}),
  /**
    * @method 关注的招标人列表
    */
  concernTenderUnit: (params) => getAction('concernTenderUnit/search', params),
  /**
    * @method 微信分享
    */
  getSignature: (params) => getAction('/wechat/share/new_index', params),
  /**
    * @method 获取关注的推送频率
    */
  getConcernCOnfig: () => getAction('getConcernConfig/search'),
  /**
    * @method 更新关注的推送频率
    */
  updateConcernConfig: (params) => getAction('concernConfig/update', params),
  /**
    * @method 获取省市新增数据  各省公告信息统计
    */
  getCountByAreaCode: (params) => postAction('/wechat/province_statistics', params),
  /**
   * @method 获取省市新增数据  各省公告信息统计
   */
  getCountByCityAreaCode: (params) => postAction('/wechat/city_statistics', params),
  /**
     * @method  清空当前的订阅结果信息
     */
  deleteUserSubscribeHistory: () => getAction('deleteUserSubscribeInfo/delete'),
  // resistIll共同抗疫模块
  /**
     * @method  疫情资讯
     */
  newsList: (params) => postAction('gkyq/news', params),
  /**
     * @method  获取每个栏目的今日新增
     */
  getNewCount: (searchType) => getAction('gkyq/announcementCount?searchType=' + searchType),
  /**
    * @method 根据类型获取地区新增公告条数
    */
  getAnnounceCountByArea: (params) => getAction('/wechat/yq_province_statistics', params),
  /**
     * @method  获取地区新增公告条数
     */
  getAnnounceTotalByArea: (params) => getAction('gkyq/announcementCountDetailForAreaCode', params),
  /**
     * @method  留言列表
     */
  feedbackSearch: (params) => getAction('/wechat/message_list', params),
  /**
     * @method  我的留言（新接口）
     */
  feedbackSearchMe: (params) => getAction('/wechat/my_message_list', params),
  /**
     * @method  我的留言（新接口）
     */
  feedbackAll: (params) => getAction('/wechat/all_message_list', params),
  /**
     * @method  获取反馈详情
     */
  feedbackDetail: (params) => getAction('feedBackInfo/search', params),
  /**
     * @method  主体详情页(新接口)
     */
  enterpriseShow: (params) => getAction('/wechat/enterprise_show', params),
  /**
     * @method  信用信息(新接口)
     */
  creditShow: (params) => getAction('/wechat/credit_show', params),
  /**
     * @method 资格资质信息(新接口)
     */
  qualient: (params) => getAction('/wechat/qualient', params),
  /**
     * @method 发布反馈（新接口）
     */
  addFeedback: (params) => postAction('/wechat/add_feedback', params),
  /**
     * @method 龙虎榜（新接口）
     */
  getRank: (params) => getAction('/wechat/new_lh_hit', params),
  /**
     * @method 相关机构（新接口）
     */
  xgjg: (params) => getAction('/wechat/xgjg', params),
  /**
     * @method 删除订阅条件（新接口）
     */
  subreadSetDel: (params) => getAction('/wechat/subread_set_del', params)

}
export default pubResApi



// WEBPACK FOOTER //
// ./src/api/api.js